import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { CmsConverterService, defaultFSCatalog } from '../../../services/cms-converter/cms-converter.service'
import { ConvertedComponentData, FsCatalog, Image } from '../../types'
import { BubbleData } from './bubble/bubble.component.converter'

@Injectable({ providedIn: 'root' })
export class TeaserWithBubblesConverter extends CmsConverterService<TeaserWithBubblesData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    const altText = formData.st_alt_text?.value
    const title = formData.st_title_text?.value
    const lazyLoad = formData.st_image_lazy_loading?.value
    return {
      image: CmsConverterService.mapImage(formData.st_image_reference, lazyLoad, altText, title),
      bubbles: formData.st_bubble_teaser_items ?? defaultFSCatalog,
    }
  }
}

export const TEASER_WITH_BUBBLES_CONVERTER_TOKEN = new InjectionToken<Converter<CmsComponent, TeaserWithBubblesData>>('BubbleWrapperConverter')

export interface TeaserWithBubblesData extends ConvertedComponentData {
  image: Image;
  bubbles: FsCatalog<BubbleData>;
}
